module.exports = __webpack_public_path__ + "img/4.a59a1d1a.jpg";